export const strokeDash1Icon = {
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M1 9v2h5V9zm7 0v2h5V9zm7 2V9h4v2z"/></svg>`,
  name: 'stroke-dash-1',
};
